<div class="data no-text-select" [ngClass]="{'borderTop' : !first}">
    <div class="data-form">

        <h3 class="data-section-title">Datos personales</h3>
        <div class="data-table">
            <div class="data-table-header">
                <div class="col col-name">Nombre completo</div>
                <div class="col col-doc">Nº documento</div>
                <div class="col col-birth">Fecha de nacimiento</div>
                <div class="col col-email">E-mail</div>
                <div class="col col-tel">Teléfono</div>
                <div class="col col-dir">Dirección completa</div>
                <div class="col col-province">Provincia</div>
            </div>
            <div class="data-table-row">
                <div class="col col-name">{{insured.name}}</div>
                <div class="col col-doc">{{insured.documentNumber}}</div>
                <div class="col col-birth">{{insured.bornDate | date: 'dd/MM/yyyy'}}</div>
                <div class="col col-email">{{insured.email}}</div>
                <div class="col col-tel">{{insured.mobilePhone}}</div>
                <div class="col col-dir">{{insured.address}}</div>
                <div class="col col-province">{{insured.province}}</div>
            </div>
        </div>

        <h3 class="data-section-title data-section-title--fiscal">Datos fiscales</h3>
        <div class="data-table">
            <div class="data-table-header">
                <div class="col col-fiscal-dir">Dirección fiscal</div>
                <div class="col col-fiscal-province">Provincia</div>
            </div>
            <div class="data-table-row">
                <div class="col col-fiscal-dir">{{insured.fiscalAddress}}</div>
                <div class="col col-fiscal-province">{{insured.fiscalProvince}}</div>
            </div>
        </div>

    </div>
</div>
